import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { ChevronRight, Barcode as BarcodeIcon, Check } from 'lucide-react';
import BarcodeScanner from '../components/BarcodeScanner';

const BarcodeCaptureScreen = () => {
  const { setCurrentScreen, updateScanData } = useApp();
  const [showScanner, setShowScanner] = useState(false);
  const [barcodeValue, setBarcodeValue] = useState('');

  const handleBarcodeScan = (code) => {
    setBarcodeValue(code);
    setShowScanner(false);
  };

  const handleManualEntry = () => {
    const code = prompt('Enter barcode manually:');
    if (code) {
      setBarcodeValue(code);
    }
  };

  const handleDone = () => {
    if (barcodeValue) {
      updateScanData({
        barcode: { active: true, data: barcodeValue }
      });
      setCurrentScreen('scan');
    }
  };

  return (
    <div className="min-h-screen bg-black pb-24 flex flex-col">
      <div className="px-6 pt-6 pb-4 flex items-center gap-4">
        <button
          onClick={() => setCurrentScreen('scan')}
          className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center hover:bg-white/20 transition-all flex-shrink-0"
        >
          <ChevronRight size={18} className="text-white rotate-180" />
        </button>
        <img src="/logos/logo-black.jpg" alt="ATELIA" className="h-16 w-auto object-contain" style={{ filter: 'invert(1)' }} />
      </div>

      <div className="flex-1 flex flex-col items-center justify-center px-6">
        <div className="w-20 h-20 bg-white/10 rounded-3xl flex items-center justify-center mb-8">
          <BarcodeIcon size={36} className="text-white" strokeWidth={1.5} />
        </div>

        <h1 className="text-3xl font-bold text-white text-center mb-4 uppercase tracking-wide">
          Scan Barcode
        </h1>

        <p className="text-white/70 text-center text-sm max-w-xs mb-8 leading-relaxed">
          Position the barcode within the camera frame for instant product lookup.
        </p>

        {barcodeValue && (
          <div className="bg-white/10 rounded-xl px-6 py-3 mb-6">
            <p className="text-white font-mono text-center">{barcodeValue}</p>
          </div>
        )}

        <div className="w-full max-w-sm space-y-3">
          <button
            onClick={() => setShowScanner(true)}
            className="w-full bg-white text-black py-4 px-8 rounded-2xl
              font-bold uppercase tracking-wide hover:bg-white/90 transition-all
              flex items-center justify-center gap-3"
          >
            <BarcodeIcon size={20} />
            Scan Barcode
          </button>

          <button
            onClick={handleManualEntry}
            className="w-full bg-white/10 border border-white/20 text-white py-4 px-8 rounded-2xl
              font-bold uppercase tracking-wide hover:bg-white/20 transition-all
              flex items-center justify-center gap-3"
          >
            Enter Manually
          </button>

          {barcodeValue && (
            <button
              onClick={handleDone}
              className="w-full bg-white text-black py-4 px-8 rounded-2xl
                font-bold uppercase tracking-wide hover:bg-white/90 transition-all
                flex items-center justify-center gap-3"
            >
              <Check size={20} />
              Done
            </button>
          )}
        </div>
      </div>

      <div className="px-6 pb-8">
        <div className="bg-white/5 rounded-xl p-4 border border-white/10">
          <p className="text-white/80 font-semibold text-xs uppercase mb-2">Barcode Tips</p>
          <p className="text-white/60 text-xs leading-relaxed">
            • Most accurate with UPC/EAN barcodes
            • Ensure barcode is not damaged or wrinkled
            • Hold camera steady until beep/vibration
          </p>
        </div>
      </div>

      <BarcodeScanner
        isOpen={showScanner}
        onClose={() => setShowScanner(false)}
        onScan={handleBarcodeScan}
      />
    </div>
  );
};

export default BarcodeCaptureScreen;
